export enum AuthState {
  LOADING = "LOADING",

  FULL = "FULL", // can access homescreen

  PHONE_VERIFICATION_REQUIRED = "PHONE_VERIFICATION_REQUIRED", // former status - unverified
  PASSWORD_REQUIRED = "PASSWORD_REQUIRED", // former status - onboarding
  ONBOARDING_REQUIRED = "ONBOARDING_REQUIRED", // former status - enrolling

  INTEGRATION_ERROR = `integration_error`,

  UNAUTHED = `UNAUTHED`
}

export enum Features {
  TRUSTED_KYC = "trusted_kyc",
  API_ACCESS = "api_access",
  BOOM_SCREEN = "boom_screen",
  BYPASS_BANK_LINKING = "bypass_bank_linking",
  DELINQUENCY_REPORTING = "delinquency_reporting",
  FREE_CHECKOUT = "free_checkout",
  FREE_ONGOING = "free_ongoing",
  SDK = "sdk",
  PLAID_SHARED_TOKEN = "plaid_shared_token"
}
export enum RenterBenefit {
  RENT_REPORTING = "rent_reporting",
  CREDIT_MONITORING = "credit_monitoring",
  IDENTITY_THEFT_PROTECTION = "identity_theft_protection"
}
type Partner = {
  id?: number;
  name: string;
  features: Features[];
  renter_benefits?: RenterBenefit[];
  logo_url?: string;
  asset_logo_url?: string;
  base_border_radius?: string;
  font_family?: string;
  font_family_link?: string;
  colors?: {
    primary?: {
      "20"?: string;
      "50"?: string;
      "100"?: string;
      "200"?: string;
      "300"?: string;
      "400"?: string;
      "500"?: string;
      "600"?: string;
      "700"?: string;
      "800"?: string;
      "900"?: string;
    };
    background?: {
      "1000"?: string;
      "900"?: string;
      "800"?: string;
    };
  };
};

export type Customer = {
  id: number;
  phone_verified: boolean;
  onboarded: boolean;
  array_client_key: null | unknown;
  applied_for_enrollment: boolean;
  email_verified: boolean;
  partner?: Partner;
  first_name?: string;
  last_name?: string;
  name?: string; // full name `${firstName} ${lastName}`
  email?: string;
  phone?: string; //unformatted phone number
  us_phone?: string; // formatted phone number
  created_at?: string;
  partner_service_type?: string;
};

export type Context = {
  authState: AuthState;
  token?: string;
  customer?: Customer;
  partner?: Customer["partner"];
  error?: string;
  logOut: () => Promise<void>;
  refreshAuth: (data?: Customer) => Promise<void>;
  sdkConfig: {
    hasClose?: boolean;
    bypassPlaidAccountConfirmation?: boolean;
    withIntercom?: boolean;
  };
  pms?: {
    isManageAmerica: boolean;
  };
};
